// @flow
import * as React from 'react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { makeStyles, MenuItem } from '@material-ui/core';
import classNames from 'classnames';

import ArrowDown from '../../images/ArrowDownSmallIcon.svg';
import CheckIcon from '../../images/check_icon.svg';
import { InputField } from '../InputField/InputField';

// TODO_R: [FRS]
const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    position: 'relative',
    '&>*': {
      cursor: 'pointer',
    },
    '& input::placeholder': {
      color: '#fff',
      opacity: 1,
    },
  },
  background: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'transparent',
    zIndex: 8,
  },
  dropdown: {
    position: 'absolute',
    right: 32,
    left: 32,
    color: '#ABABAB',
    fontSize: '18px',
    background: '#2F2F34',
    borderRadius: '6px',
    display: 'grid',
    cursor: 'pointer',
    // width: '88%',
    width: 'calc(100% - 64px)',
    marginTop: 65,
    transform: 'scaleY(0.01)',
    opacity: 0,
    transition: 'transform 0.25s ease, opacity 0.25s ease, box-shadow 0.25s ease 0.15s',
    transformOrigin: 'center top',
    overflow: 'hidden',
    zIndex: 9,
    padding: '8px 12px',
    maxHeight: '300px',
    [theme.breakpoints.down('md')]: {
      right: 24,
      left: 24,
      width: 'calc(100% - 48px)',
      maxWidth: '560px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 32px)',
      right: 16,
      left: 16,
      maxWidth: 'calc(100% - 32px)',
    },
  },
  dropdownOpen: {
    marginTop: 55,
    margin: '3px auto',
    transform: 'scaleY(1)',
    opacity: 1,
    maxHeight: '300px',
    overflowY: 'scroll',
    zIndex: 999,
    background: '#34353B',
    height: 'min-content',
    borderRadius: 12,

    '&::-webkit-scrollbar': {
      width: '3px',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#376BDA2A',
    },
  },
  menu: {
    '& li': {
      '&:first-child': {
        display: 'none',
      },
      '&.Mui-selected': {
        background: '#34353B!important',

        '&:after': {
          width: 15,
          height: 15,
          background: `url('${CheckIcon}') no-repeat center center`,
          content: '""',
          marginLeft: 'auto',
          top: 10,
          right: 20,
        },
      },

      fontWeight: 500,
      fontSize: 14,
      lineHeight: '20px',
      '&:hover': {
        background: '#42444B',
      },
    },
  },
  icon: {
    position: 'absolute',
    top: 20,
    right: 17,
    cursor: 'pointer',
    transition: 'all ease 0.3s',
  },
  iconOpened: {
    transform: 'rotate(180deg)',
  },
}));

type Props = {
  selectedCollection: string;
  collections: string[];
  collectionDropDownOpened: boolean;
  onChange: (collection: string) => void;
  setCollectionDropDownOpened: Dispatch<SetStateAction<boolean>>;
};

// TODO_R: [FRS]
// TODO_R: move into SendNFTDialog/components
// TODO_R: [RP] NFTCollectionSelect
export const SelectCollectionField = ({
  selectedCollection,
  onChange,
  collections,
  collectionDropDownOpened,
  setCollectionDropDownOpened,
}: Props) => {
  const classes = useStyles();
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!value && selectedCollection) {
      setValue(selectedCollection.split('::')[1]);
    }
  }, []);

  return (
    <>
      {/* TODO_R: use @material-ui Select instead */}
      {collectionDropDownOpened && (
        <div
          onClick={() => setCollectionDropDownOpened((prevState) => !prevState)}
          className={classes.background}
        ></div>
      )}
      <div
        className={classNames(classes.inputWrapper)}
        onClick={() => setCollectionDropDownOpened((prevState) => !prevState)}
      >
        <InputField disabled onChange={setValue} value={value} placeHolder="Choose collection" />
        <img
          className={classNames(classes.icon, collectionDropDownOpened ? classes.iconOpened : '')}
          src={ArrowDown}
          alt="Arrow Down"
        />
      </div>
      {collectionDropDownOpened && (
        <div
          className={classNames(classes.dropdown, collectionDropDownOpened && classes.dropdownOpen)}
        >
          {collections.map((collection) => (
            <MenuItem
              onClick={
                // TODO_R: move into handleCollectionSelect
                () => {
                  setValue(collection.split('::')[1]);
                  onChange(collection);
                  setCollectionDropDownOpened((prevState) => !prevState);
                }
              }
              key={collection}
              value={collection}
            >
              {collection.split('::')[1]}
            </MenuItem>
          ))}
        </div>
      )}
    </>
  );
};
